/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEvePastDueNoticeData } from './eve-past-due-notice.data';
import { IEvePastDueNoticeProps } from './eve-past-due-notice.props.autogenerated';

export interface IEvePastDueNoticeViewProps extends IEvePastDueNoticeProps<IEvePastDueNoticeData> {
    shouldRenderMessage: boolean;
}

/**
 *
 * EvePastDueNotice component
 * @extends {React.PureComponent<IEvePastDueNoticeProps<IEvePastDueNoticeData>>}
 */
class EvePastDueNotice extends React.PureComponent<IEvePastDueNoticeProps<IEvePastDueNoticeData>> {
    public render(): JSX.Element | null {
        const {
            data: { pastDue },
            context: {
                request: {
                    user: { isAuthenticated }
                }
            }
        } = this.props;
        if (!isAuthenticated || !pastDue?.result?.hasAccountInCredit) {
            return null;
        }
        return this.props.renderView(this.props);
    }
}

export default EvePastDueNotice;
